import { useEffect, useRef, useState } from 'react';

function FaceMeshAnimation() {
  const canvasRef = useRef(null);
  const [landmarks, setLandmarks] = useState([]);

  useEffect(() => {
    fetch('/facemesh_landmarks.json')
      .then(res => res.json())
      .then(data => setLandmarks(data))
      .catch(err => console.error('❌ 랜드마크 로딩 실패:', err));
  }, []);

  useEffect(() => {
    if (landmarks.length === 0) return;

    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // 중심 위치 & 스케일 계산
    const minX = Math.min(...landmarks.map(p => p.x));
    const maxX = Math.max(...landmarks.map(p => p.x));
    const minY = Math.min(...landmarks.map(p => p.y));
    const maxY = Math.max(...landmarks.map(p => p.y));

    const faceCenterX = (minX + maxX) / 2;
    const faceCenterY = (minY + maxY) / 2;

    const canvasCenterX = canvas.width / 2;
    const canvasCenterY = canvas.height / 2;

    const scale = 1.5; // 확대 배율

    const animate = (time) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = "#fdf6ec";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // 위치 보정 + 확대 + 흔들림
      const animatedPoints = landmarks.map((pt, i) => {
        const dx = Math.sin(time * 0.002 + i) * 1.2;
        const dy = Math.cos(time * 0.002 + i) * 1.2;

        return {
          x: (pt.x - faceCenterX) * scale + canvasCenterX + dx,
          y: (pt.y - faceCenterY) * scale + canvasCenterY + dy
        };
      });

      // 점 그리기
      animatedPoints.forEach((pt) => {
        ctx.beginPath();
        ctx.arc(pt.x, pt.y, 1.6, 0, Math.PI * 2); // 점 반지름 ↓
        ctx.fillStyle = "#a97452";
        ctx.fill();
      });

      // 인접선 간단 연결
      ctx.strokeStyle = "#b08968";
      ctx.lineWidth = 0.5;
      for (let i = 0; i < animatedPoints.length - 1; i++) {
        const a = animatedPoints[i];
        const b = animatedPoints[i + 1];
        ctx.beginPath();
        ctx.moveTo(a.x, a.y);
        ctx.lineTo(b.x, b.y);
        ctx.stroke();
      }

      requestAnimationFrame(animate);
    };

    animate(0);
  }, [landmarks]);

  return (
    <canvas
      ref={canvasRef}
      width={500}
      height={500}
      style={{
        backgroundColor: '#fdf6ec',
        borderRadius: '1rem',
        width: '100%',
        maxWidth: '100%',
        display: 'block',
        margin: '0 auto'
      }}
    />
  );
}

export default FaceMeshAnimation;
